import Tabs from './tabs';

export default class RadioTabs extends Tabs {

/*-- Private methods ---------------------------------------------------------*/

  _activateTab(radio) {
    radio.checked = true;
  }

  _deactivateTab(radio) {
    radio.checked = false;
  }

  _bindTabs() {
    this._tabs.forEach ( radioInput => {
      radioInput.addEventListener('change', event => {
        if (!event.currentTarget.disabled) {
          this.activate(radioInput.getAttribute(this._options.dataAttr));
        } // Else do nothing
      }, true);
    });
  }
}



// WEBPACK FOOTER //
// ./assets/javascripts/libs/radio_tabs.js